import React from 'react';

import { SvgIcon } from '@mui/material';

import AppIconPillButton, {
  IAppIconPillButtonProps,
} from '../app-icon-pill-button/AppIconPillButton';

export function AppPlayPillButton({
  colorVariant = 'secondary',
  ...props
}: IAppIconPillButtonProps) {
  return (
    <AppIconPillButton colorVariant={colorVariant} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <polygon points="6 3 20 12 6 21 6 3"></polygon>
      </svg>
    </AppIconPillButton>
  );
}

export default AppPlayPillButton;
